module.exports = __webpack_public_path__ + "assets/images/5-2Kr5TZ2.jpg";